import { MdEdit } from 'react-icons/md'

import type { ReactElement } from 'react'

import Button from '~/components/Buttons/Button'

import './styles.scss'

interface Props {
  selectedRowStatuses?: string[]
  selectedRows?: string[]
  setIsAddPropertiesModalOpen: (isOpen: boolean) => void
  setIsChangeStatusModalOpen: (isOpen: boolean) => void
  setIsUpdateAssetModalOpen: (isOpen: boolean) => void
}

const EditControls = ({
  selectedRows,
  selectedRowStatuses,
  setIsAddPropertiesModalOpen,
  setIsChangeStatusModalOpen,
  setIsUpdateAssetModalOpen,
}: Props): ReactElement => {
  const handleAddPropertiesClick = () => {
    setIsAddPropertiesModalOpen(true)
  }

  const handleChangeStatusClick = () => {
    setIsChangeStatusModalOpen(true)
  }

  const handleUpdateAssetClick = () => {
    setIsUpdateAssetModalOpen(true)
  }

  const getControlsMenu = (selectedRows?: string[]) => {
    if (selectedRows && selectedRows.length < 2) {
      return (
        <Button onClick={handleUpdateAssetClick}>
          <MdEdit color="#fff" size={14} />
        </Button>
      )
    } else {
      return (
        <div className="multi-select-buttons-wrapper">
          <Button onClick={handleAddPropertiesClick} outlined>
            Add properties
          </Button>
          {selectedRowStatuses?.every((val, _i, arr) => val === arr[0]) && (
            <Button onClick={handleChangeStatusClick}>Change status</Button>
          )}
        </div>
      )
    }
  }

  return getControlsMenu(selectedRows)
}
export default EditControls
